import React, { useEffect } from 'react';
import Form from './form';
import TableContent from './table';
import TableTools from './tableTools';
import { SManageShareholderPage } from '../../../../styles/styled/admin/manageShareholderPage';
import {
  getTopic1Api,
  getTopic2Api,
  getTopic3Api,
  getTopic4Api,
  getTopic6Api,
} from '../../../../states/duck/pages/admin/shareholderStatusReducer/actions';
import { useDispatch } from 'react-redux';
const ManageShareholderPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTopic1Api(1));
    dispatch(getTopic2Api(2));
    dispatch(getTopic3Api(3));
    dispatch(getTopic4Api(4));
    dispatch(getTopic6Api(6));
  }, [dispatch]);
  return (
    <SManageShareholderPage>
      <Form />
      <TableTools />
      <TableContent />
    </SManageShareholderPage>
  );
};
export default ManageShareholderPage;
